import type { NoodlNode, Props } from '@shared/node-v1.0.0'
import { sendSignal } from '@shared/port-send-v1.0.0'
import { App } from '@capacitor/app'


// Глобальная переменная для предотвращения множественной регистрации
let isBackButtonRegistered = false

// Данная функция должна принимать схему для создания классов, создавать их и публиковать функции для работы с ними в R.localData
export default async (p: Props, noodlNode: NoodlNode) => {

    // Регистрируем слушатель кнопки "Назад" только один раз
    if (p.useMobileButtons && !isBackButtonRegistered) {
        try {
            console.log('🎯 Пытаемся зарегистрировать слушатель кнопки "Назад"')
            
            await App.addListener('backButton', (data) => {
                console.log('🚀 Кнопка "Назад" нажата!', data)
                
                // R.libs.mantine.MantineError('Нажата назад', 'Отловили нажатие назад', false)
                sendSignal(noodlNode, 'backButtonClick')
                
                // // Дополнительная логика если нужно
                // if (data.canGoBack) {
                //     console.log('✅ Можем вернуться назад в истории')
                //     // window.history.back() // если нужно
                // } else {
                //     console.log('❌ Нельзя вернуться назад')
                // }
            })
            
            isBackButtonRegistered = true
            console.log('✅ Слушатель кнопки "Назад" успешно зарегистрирован!')
            
        } catch (error) {
            console.error('❌ Ошибка при регистрации слушателя кнопки "Назад":', error)
        }
    }

    return Promise.resolve()
}
